import { PATH_NAMES } from '~/ocab-services/childrens-shoe-fitting/constants/path-names.constants';

export const config = {
  firstPagePath: PATH_NAMES.FITTING_TYPE,
  childrensAppointmentTypesNextPath: PATH_NAMES.SELECT_SHOP,
  shopsPrevPath: PATH_NAMES.FITTING_TYPE,
  shopsNextPath: PATH_NAMES.SELECT_DATE,
  selectDatePrevPath: PATH_NAMES.SELECT_SHOP,
  aboutYouPrevPath: PATH_NAMES.SELECT_DATE,
  reviewPrevPath: PATH_NAMES.ABOUT_YOU,

  editShopNextPath: PATH_NAMES.EDIT_DATE,
  editDatePrevPath: PATH_NAMES.EDIT_SHOP,
};
